import type {Expand} from '../types';

import {userQuestionnaireExpandCommon} from '../questionnaire';
import {userExpandCommon} from '../user';

export const inviteExpandCommon: Expand = {
  invite: [
    ['coach_id', {coach_title: 'Coach not found'}, userExpandCommon],
    [
      'user_questionnaire_id',
      {title: 'Questionnaire not found'},
      userQuestionnaireExpandCommon,
    ],
  ],
};
